export const FORM_LABEL_CLASS = 'block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5';

export const FORM_INPUT_CLASS =
  'w-full border border-gray-100 rounded-lg px-3 py-2.5 text-sm text-gray-900 placeholder-gray-400 bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors';

export const FORM_SELECT_CLASS = `${FORM_INPUT_CLASS} appearance-none`;

export const FORM_TEXTAREA_CLASS = `${FORM_INPUT_CLASS} resize-none`;
